import React, {Fragment, useContext} from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";
import {getChildRouterLink} from "root/Wieldy/routePaths";
import GlobalContext from "root/contexts/GlobalContext";
import {getMessagingMenuTypeForUser, MessagingMenus} from "root/DataFunctions/PageContentRoles";
import {LetterBoxFilter, LetterBoxMenuTitles} from "root/DataFunctions/Constants";
import {useLocation} from "react-router-dom";
import queryString from "query-string";

const ChildLetterboxSubmenu = (props ) =>
{
    const globals = useContext(GlobalContext);
    const menuType = getMessagingMenuTypeForUser(globals.userType);

    const {search} = useLocation();
    const queryParams = queryString.parse(search);

    const letterbox_status_filter = queryParams.type === undefined ? LetterBoxFilter.UNAPPROVED : queryParams.type;

    const managerLetterboxSubmenu = () =>
    {
        return (
            <AppSidebarGroup title='Letterbox' default={letterbox_status_filter}>
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'letterbox?type=' + LetterBoxFilter.ALL)} title={LetterBoxMenuTitles.ALL} iconName='icon-email' name={LetterBoxFilter.ALL} />
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'letterbox?type=' + LetterBoxFilter.UNAPPROVED)} title={LetterBoxMenuTitles.UNAPPROVED} iconName='icon-important' name={LetterBoxFilter.UNAPPROVED}/>
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'letterbox?type=returnedbyeditor')} title='Returned by Editor' iconName='icon-question-circle' name={LetterBoxFilter.RETURNED_BY_EDITOR}/>
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'letterbox?type=returnedtosender')} title='Returned to Sender' iconName='icon-question-circle' name={LetterBoxFilter.RETURNED_BY_LETTERBOX}/>
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'letterbox?type=approved')} title='Approved' iconName='icon-thumb-up' name={LetterBoxFilter.APPROVED}/>
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'calendar')} title={LetterBoxMenuTitles.CALENDAR} iconName='icon-calendar' name={LetterBoxMenuTitles.CALENDAR}/>
            </AppSidebarGroup>
        )
    }

    const contributorLetterboxSubmenu = () =>
    {
        //
    }

    const menuSection = (menuType) =>
    {
        switch (menuType)
        {
            case MessagingMenus.MANAGER:
                return managerLetterboxSubmenu();
            case MessagingMenus.CONTRIBUTOR:
                return contributorLetterboxSubmenu();
            default:
                throw new Error("Invalid Menu Type");
        }
    }

    return (
        <Fragment>
            {menuSection(menuType)}
        </Fragment>
    )
}

export default ChildLetterboxSubmenu ;